export default {"src":"/_next/static/media/molding.e5364691.svg","height":160,"width":160};